import { render, staticRenderFns } from "./ContractFormv2.vue?vue&type=template&id=080c63fa&scoped=true&"
import script from "./ContractFormv2.vue?vue&type=script&lang=js&"
export * from "./ContractFormv2.vue?vue&type=script&lang=js&"
import style0 from "./ContractFormv2.vue?vue&type=style&index=0&id=080c63fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c63fa",
  null
  
)

export default component.exports